import { Component, HostListener, OnDestroy, ViewEncapsulation } from '@angular/core'
import {
  WebsitePreviewData,
  WebsitePreviewItemContext,
  WebsitePreviewPackage,
  WebsitePreviewTab,
} from './ibranson-preview.iface'
import { enterIbransonPreviewPage, leaveIbransonPreviewPage } from './ibranson-preview-styles'
import { loadIbransonPreview } from './ibranson-preview.storage'

@Component({
  selector: 'app-ibranson-preview-page',
  templateUrl: './ibranson-preview-page.component.html',
  styleUrls: ['./ibranson-preview.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class IbransonPreviewPageComponent implements OnDestroy {
  cover: string | null = null
  coverAds: string | null = null
  coverStripe: string | null = null
  gallery: string[] = []
  seatMap: string | null = null
  unclassified: string[] = []
  item: WebsitePreviewItemContext = {}
  packages: WebsitePreviewPackage[] = []
  activeTab: WebsitePreviewTab = 'overview'
  private scrollingTo: WebsitePreviewTab | null = null

  get heroSrc(): string | null {
    return this.coverStripe || this.cover
  }

  get categoryLabel(): string {
    const plural = this.item?.categoryPlural || 'shows'
    if (plural === 'hotels') {
      return 'Lodging'
    }
    return plural.charAt(0).toUpperCase() + plural.slice(1)
  }

  get showTimeLabel(): string {
    const sl = this.item?.showLength
    if (!sl) {
      return ''
    }
    let minutes = 0
    if (typeof sl === 'number') {
      minutes = sl
    } else {
      const d = new Date(sl)
      if (!isNaN(d.getTime())) {
        minutes = d.getHours() * 60 + d.getMinutes()
      }
    }
    if (!minutes) {
      return ''
    }
    let label = `Time ${minutes} min.`
    const count = this.item?.intermissions
    if (count) {
      const len = this.item?.intermissionLength
      label += ` (${count} Intermission${count > 1 ? 's' : ''}${len ? ' for ' + len + 'min' : ''})`
    }
    return label
  }

  get venueLine(): string {
    return [this.item?.venueName, this.item?.venueAddress].filter(Boolean).join(', ')
  }

  constructor() {
    enterIbransonPreviewPage()
    const data: WebsitePreviewData = loadIbransonPreview() || {}
    this.cover = data.cover || null
    this.coverAds = data.coverAds || null
    this.coverStripe = data.coverStripe || null
    this.gallery = data.gallery || []
    this.seatMap = data.seatMap || null
    this.unclassified = data.unclassified || []
    this.item = data.item || {}
    this.packages = data.packages || []
  }

  ngOnDestroy() {
    leaveIbransonPreviewPage()
  }

  scrollToSection(event: Event | null, tab: WebsitePreviewTab) {
    event?.preventDefault()
    this.activeTab = tab
    this.scrollingTo = tab
    const target = document.getElementById(tab)
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    window.setTimeout(() => {
      this.scrollingTo = null
    }, 450)
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    if (this.scrollingTo) {
      return
    }
    const ids: WebsitePreviewTab[] = ['overview', 'availability', 'gallery']
    let current: WebsitePreviewTab = 'overview'
    for (const id of ids) {
      const el = document.getElementById(id)
      if (!el) {
        continue
      }
      if (el.getBoundingClientRect().top <= 96) {
        current = id
      }
    }
    this.activeTab = current
  }
}
